// import { routerReducer } from 'react-router-redux';
// import { reducer as formReducer } from 'redux-form';
// import { reducer as toastrReducer } from 'react-redux-toastr';
import { loadingBarReducer } from 'react-redux-loading-bar';
import test1Reducer from './test1Reducer';
import test2Reducer from './test2Reducer';
import raceReducer from './raceReducer';
import updatePageReducer from './updatePageReducer';
import scratchReducer from './scratchReducer';
import pointsRaceReducer from './pointsRaceReducer';
import ttReducer from './ttResultsReducer';
import keirinReducer from './keirinReducer';
import sprintTournamentReducer from './sprintTournamentReducer';
import liveReducer from './liveReducer';

const rootReducer = {
    // routing: routerReducer,
    // form: formReducer,
    // toastr: toastrReducer,
    loadingBar: loadingBarReducer,
    dataLive: test1Reducer,
    dataLive2: test2Reducer,
    race: raceReducer,
    updatePage: updatePageReducer,
    scratch: scratchReducer,
    points: pointsRaceReducer,
    TT: ttReducer,
    keirin: keirinReducer,
    sprintTournament: sprintTournamentReducer,
    live: liveReducer,
};

export default rootReducer;
